import React, { useState, useEffect } from 'react';
import { Tabs, Tab } from '@mui/material';
import Scheduler from './Calendar'; // Importa el componente Scheduler desde Calendar.jsx

const AgendaPage = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [refreshKey, setRefreshKey] = useState(0);
  const [focusDate, setFocusDate] = useState(null);

  const user = JSON.parse(localStorage.getItem("user")) || {};
  const role = user.role || (user.groups ? user.groups[0] : null);
  const username = user.username;

  console.log("User role:", role);
  console.log("Username:", username);

  const handleRefresh = (date = null) => {
  setRefreshKey(old => old + 1);
  if (date) {
    setFocusDate(date); // guardamos la fecha en la que queremos centrar el calendario
  }
};

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
  };

    const tabs = [
    { label: "Lukitas", key: "Lukitas" },
    { label: "Richy", key: "Richy" },
  ];

  let visibleTabs = tabs;
  if (role === "Instalador") {
    visibleTabs = tabs.filter(tab => tab.key === username);
  }

    // 🔧 Asegurar que el índice seleccionado siempre sea válido
  useEffect(() => {
    if (selectedTab >= visibleTabs.length) {
      setSelectedTab(0);
    }
  }, [visibleTabs, selectedTab]);
  return (
    <div className="h-full flex flex-col p-2 md:p-4 overflow-hidden">
      <div className="flex-1 min-h-0 flex flex-col bg-white rounded-3xl p-2 md:p-3 overflow-hidden">
      <div className="flex justify-between items-center mb-2 flex-wrap gap-2">
        <p className="text-xl md:text-3xl font-extrabold tracking-tight text-slate-900">Agenda</p>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          aria-label="agenda tabs"
          sx={{
            '.MuiTab-root': { '&:hover': { color: '#FF743A' }, '&.Mui-selected': { color: '#FF743A' } },
            '.MuiTabs-indicator': { backgroundColor: '#FF743A' },
          }}
        >
          {visibleTabs.map((tab, index) => (
            <Tab key={tab.key} label={tab.label} />
          ))}
        </Tabs>
      </div>

      <div className="flex-1 min-h-0 overflow-hidden">
        {visibleTabs.map((tab, index) => (
          selectedTab === index && (
            <div key={tab.key} className="h-full overflow-hidden">
              <Scheduler
                key={`${refreshKey}-${tab.key}`}
                onRefresh={handleRefresh}
                focusDate={focusDate}
                vehicle={tab.key}
              />
            </div>
          )
        ))}
      </div>
      </div>
    </div>
  );
};

export default AgendaPage;
